import React, { Fragment,useState } from "react";
import { ICustomizedItem } from "../../../../models/item.model";
import { IItems } from "../../../../models/try2Combo";
import { Try2ItemDetailsModal } from "./Try2ItemDetailsModal";
import useCheckMobileScreen from "../../../../hooks/useCheckMobileScreen";
import TryItemDescription from "../../TryItemListing/TryItemDescription";
import { getFilteredItems } from "../../../../helpers/helperMethods";
import styleClasses from "./Try2ComboItems.module.scss";

const Try2ComboItems: React.FC<IItems> = (props) => {
  const {
    category,
    selectedFilters,
    userId,
    favButtonHandler,
    favIcon,
    favourite,
    customizeModal,
    addToComboClickHandler,
    userType,
    showItemDetails
  } = props;


  const [showMore, setShowMore] = useState(false);
  const isItMobile = useCheckMobileScreen();
  const [itemDetails, setItemDetails] = useState<IItems>({} as IItems);
  // const [divHeight, setDivHeight] = useState(0);
  // const itemHeight = useRef(null);
  // const heightSetRef = useRef(null);
  // const history = useHistory()
  
  const showDetailsHandler = (e,item) => {
    setShowMore(true);
    setItemDetails(item);
    e.stopPropagation();
  };

  const closeDetailsModal = () => {
    setShowMore(false);
  };


  // useEffect(() => {
  //   console.log("heightSetRef.current",heightSetRef.current)

  //   if ((!divHeight || divHeight <= 0)  && itemHeight?.current?.scrollHeight && filteredIitems.length &&  heightSetRef.current === null) {
  //     setDivHeight(itemHeight?.current?.scrollHeight);
  //     heightSetRef.current = true;
  //   }
  // }, [filteredIitems, history.location.pathname]);
  // console.log('After height: ', divHeight);

  const categoryItems = getFilteredItems(category?.items, selectedFilters)

  if (!categoryItems?.length)
    return (
      <div className={`${styleClasses.no_item__wrap} mx-auto`}>
        <h5 className="font-Cls f-s30 f-sm-s24 mb-3">0 results found</h5>
        <p className="f-s16 mb-0">
          Sorry! We couldn’t find what you were looking for. Might we suggest
          some Cafe Zupas fan favorites...
        </p>
      </div>
    );

  return (
    <Fragment>
      {categoryItems?.map((item: ICustomizedItem) => (
      <TryItemDescription
          key={item.id}
          item={item}
          addToComboClickHandler={addToComboClickHandler}
          customizeModal={customizeModal}
          showDetailsHandler={showDetailsHandler}
          category={category}
          favourite={favourite}
          favButtonHandler={favButtonHandler}
          favIcon={favIcon}
          userId={userId}
          userType={userType} 
          showItemDetails={showItemDetails}
          />
      ))}
      <Try2ItemDetailsModal
        showModal={showMore}
        closeModal={closeDetailsModal}
        itemDetials={itemDetails}
      />
    </Fragment>
  );
};

export default Try2ComboItems;
